import { Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import LocationPicker from '../../../features/location-management/components/LocationPicker';
import { useGetLocations } from '../../../features/location-management/hooks/useGetLocations';
import { useSelectedLocation } from '../../../features/location-management/hooks/useSelectedLocation';
import OrganizationPicker from '../../../features/organization/components/OrganizationPicker';
import { useSelectedOrganization } from '../../../features/organization/hooks/useSelectedOrganization';

export function SearchBar(props: { [x: string]: any }) {
	const { variant, background, children, placeholder, borderRadius, ...rest } = props;
	const { selectedLocation, setSelectedLocation } = useSelectedLocation();
	const { selectedOrganization } = useSelectedOrganization();
	const { data: locations } = useGetLocations(selectedOrganization?.id);

	useEffect(() => {
		if (locations && locations.length) {
			if (!selectedLocation)
				setSelectedLocation(locations[0]);
			else if (selectedLocation && !locations.find(location => location.id === selectedLocation.id)) {
				setSelectedLocation(locations[0]);
			}
		}
	}, [locations]);

	return (
		<Flex align='center' gap='12px' {...rest}>
			<OrganizationPicker />
			<LocationPicker selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} />
		</Flex>
	);
}
